<template>
	<PageArrows 
		v-bind:className="'patient'"
		v-bind:linkPrev="`/patient/${which}/${content[which].prevTab}`"
		v-bind:linkNext="`/patient/${which}/${content[which].nextTab}`"
		v-bind:linkNextInterim="content[which].nextTabInterim"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:load-interim="loadInterim"
	></PageArrows>
	<ColumnLayout
		v-bind:which="which"
		v-bind:tabType="tabType"
		v-bind:content="content"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:show-overlay="showOverlay"
	></ColumnLayout>
	<teleport to="body">
		<QuestionPopup
			v-if="content[which].InterimQA && questionPopupDisplay"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:close-then="closeThen"
		></QuestionPopup>
	</teleport>
	<teleport to="body">
		<OverlayModal 
			v-if="content[which].columnOverlay && overlayDisplay" 
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:show-overlay="showOverlay"
			id="overlay-modal"
		>
			<TabbedContent
				v-bind:which="which"
				v-bind:tabType="tabType"
			>
			</TabbedContent>
		</OverlayModal>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import ColumnLayout from '@/components/ColumnLayout'
import QuestionPopup from '@/components/QuestionPopup'
import OverlayModal from '@/components/OverlayModal'
import TabbedContent from '@/components/TabbedContent.vue'
export default {
	components: {
		PageArrows,
		ColumnLayout,
		QuestionPopup,
		OverlayModal,
		TabbedContent
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'cycle-1',
			overlayDisplay: false,
			questionPopupDisplay: false,
			content: {
				carson: {
					classes: 'cycle',
					prevTab: 'diagnosis/',
					nextTab: 'cycle-2/',
					nextTabInterim: true,
					columnA: 199,
					columnAbutton: 199,
					columnButtonAction: 'show-overlay',
					columnOverlay: 'cycle-1',
					columnB: 364,
					columnC: 348,
					InterimQA: {
						layoutClass: 'two-col checkboxes carson-cycle-1',
						type: 'radio',
						question: 'How would you manage Mr. Carson\'s venetoclax dosing at the end of Cycle 1?',
						choices: [
							'Since ANC ≥500/μL, proceed to Cycle 2 of VEN+AZA',
							'Proceed to Cycle 2 but reduce venetoclax dose to 200 mg',
							'Delay Cycle 2 until neutropenia has resolved to<br> Grade 1 or 2, and resume at the same dose',
							'Delay Cycle 2 until neutropenia has resolved to<br> Grade 1 or 2, and then reduce duration of venetoclax in<br> each cycle to 21/28 days'
						],
						keepBR: true,
						answer: '0',
						answerSize: 957,
						redirect: '/patient/carson/cycle-2/'
					}
				},
				pierce: {
					classes: 'cycle cycle-1',
					prevTab: 'pre-initiation/',
					nextTab: 'final/',
					nextTabInterim: true,
					columnA: 250,
					columnB: 322,
					columnC: 340,
					InterimQA: {
						layoutClass: 'two-col checkboxes pierce-cycle-1',
						type: 'radio',
						question: 'What is your approach to Cycle 2 of VEN+AZA in light of Mrs. Pierce\'s Grade 4 neutropenia at the end of Cycle 1?',
						choices: [
							'Start Cycle 2 regardless of blood counts at the<br> end of Cycle 1',
							'Perform a bone marrow biopsy to determine if persistent<br> cytopenias are due to treatment or persistent disease, and<br> base Cycle 2 timing on the results of the bone marrow<br> assessment',
							'Perform a bone marrow biopsy to determine if persistent<br> cytopenias are due to treatment or persistent disease, and<br> hold Cycle 2 until ANC ≥500/μL irrespective of bone marrow<br> assessment result',
							'Continue to Cycle 2 but with a dose reduction<br> of both venetoclax and azacitidine'
						],
						keepBR: true,
						answer: '1',
						answerSize: 957,
						answerLong: 'Perform a bone marrow biopsy to determine if persistent cytopenias are due to treatment or persistent disease, and base Cycle 2 timing on the results of the bone marrow assessment',
						redirect: '/patient/pierce/final/'
					}
				}
			}
		}
	},
	methods: {
		loadInterim(){
			this.questionPopupDisplay = true
		},
		closeThen(redirect){

			this.questionPopupDisplay = false
			this.content[this.which].nextTabInterim = false

			if(redirect){
				this.$router.push(redirect)
			}

		},
		showOverlay(whichActions){
			switch(whichActions[0]){
				case 'show-overlay':
						this.overlayDisplay = whichActions[1]
					break;
			}
		}
	}
}
</script>
<style scoped>

</style>